"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ReactNativeFile", {
  enumerable: true,
  get: function () {
    return _validators.ReactNativeFile;
  }
});
exports.createUploadMiddleware = exports.createLink = void 0;
var _core = require("@apollo/client/core");
var _printer = require("graphql/language/printer");
var _extractFiles = _interopRequireDefault(require("./extractFiles"));
var _validators = require("./validators");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const createUploadMiddleware = _ref => {
  let {
    uri: fetchURI,
    headers,
    fetch: customFetch,
    credentials
  } = _ref;
  return new _core.ApolloLink((operation, forward) => {
    if (typeof FormData !== "undefined" && (0, _validators.isObject)(operation.variables)) {
      const {
        variables,
        files
      } = (0, _extractFiles.default)(operation.variables);
      if (files.length > 0) {
        const context = operation.getContext();
        const {
          headers: contextHeaders
        } = context;
        const formData = new FormData();
        formData.append("query", (0, _printer.print)(operation.query));
        formData.append("variables", JSON.stringify(variables));
        files.forEach(_ref2 => {
          let {
            name,
            file
          } = _ref2;
          return formData.append(name, file);
        });
        let options = {
          method: "POST",
          headers: Object.assign({}, contextHeaders, headers),
          body: formData,
          credentials: credentials
        };

        // add context.fetchOptions to fetch options
        options = Object.assign(context.fetchOptions || {}, options);
        const runtimeFetch = customFetch || fetch;
        const uri = (0, _core.selectURI)(operation, fetchURI);
        return new _core.Observable(observer => {
          runtimeFetch(uri, options).then(response => {
            operation.setContext({
              response
            });
            return response;
          }).then((0, _core.parseAndCheckHttpResponse)(operation)).then(result => {
            // we have data and can send it to back up the link chain
            observer.next(result);
            observer.complete();
            return result;
          }).catch(err => {
            if (err.result && err.result.errors && err.result.data) {
              observer.next(err.result);
            }
            observer.error(err);
          });
        });
      }
    }
    return forward(operation);
  });
};
exports.createUploadMiddleware = createUploadMiddleware;
const createLink = httpOptions => (0, _core.concat)(createUploadMiddleware(httpOptions), new _core.HttpLink(httpOptions));
exports.createLink = createLink;
//# sourceMappingURL=index.js.map